import React from 'react';
import { ChevronRightIcon, PackageCheckIcon } from 'lucide-react';
import { NowOrderStatus } from '../../lib/store';
interface NowFloatingDeliveryStatusProps {
  orderId: string;
  status: NowOrderStatus;
  estimatedDelivery: string;
  isDelayed?: boolean;
  revisedEstimatedDelivery?: string;
  onTrack: () => void;
}
const statusCopy: Record<NowOrderStatus, string> = {
  confirmed: 'Order confirmed',
  'pharmacist-review': 'Pharmacist reviewing order',
  preparing: 'Order being packed',
  packed: 'Order packed',
  'out-for-delivery': 'Courier arriving in 24 min',
  delivered: 'Order delivered'
};
export function NowFloatingDeliveryStatus({
  orderId,
  status,
  estimatedDelivery,
  isDelayed = false,
  revisedEstimatedDelivery,
  onTrack
}: NowFloatingDeliveryStatusProps) {
  const message = isDelayed ? `Courier arriving ${revisedEstimatedDelivery?.replace('Arriving ', '') || 'soon'}` : status === 'out-for-delivery' ? statusCopy[status] : `${statusCopy[status]} · ${estimatedDelivery}`;
  return <button type="button" onClick={onTrack} className="fixed inset-x-3 bottom-[70px] z-[45] flex items-center gap-3 rounded-2xl bg-[#ef4a4f] px-4 py-3 text-left text-white shadow-[0_10px_24px_rgba(111,24,29,0.28)] transition-[transform,background-color] duration-150 active:scale-[0.98] md:hidden" aria-label={`Track ${orderId}`} data-id="element-3941" data-mp="2ko3ktcv3ge19">
    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-white/20" data-id="element-3942" data-mp="2ori184my2wf8"><PackageCheckIcon className="h-5 w-5" data-id="element-3943" data-mp="211nodn2ml7uz" /></span>
    <span className="min-w-0 flex-1" data-id="element-3944" data-mp="20y9k29aeiokw"><span className="block truncate text-sm font-bold" data-id="element-3945" data-mp="1wzk9spkntn5h">{message}</span></span>
    <ChevronRightIcon className="h-5 w-5 shrink-0" data-id="element-3946" data-mp="2aqffxu3rxq5d" />
  </button>;
}